/**
 * Quote validity (#2465, split out of the 991-line workshop form).
 */

import { Paper, Typography, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { WorkshopSettings } from '@/types';

interface Props {
  settings: WorkshopSettings;
  onChange: (settings: WorkshopSettings) => void;
}

export function WorkshopSectionQuotes({ settings, onChange }: Props) {
  const { t } = useTranslation('settings');

  return (
    <>
      {/* Quotes */}
      <Typography variant="h6" fontWeight={600} gutterBottom>
        {t('quotes.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('quotes.validityDesc')}
      </Typography>

      <Paper elevation={0} sx={{ p: 3, border: 1, borderColor: 'divider', mb: 4 }}>
        <TextField
          fullWidth
          type="number"
          label={t('quotes.validityDays')}
          helperText={t('quotes.validityDaysHint')}
          value={settings.defaultQuoteValidityDays}
          onChange={(e) => {
            const val = parseInt(e.target.value, 10);
            if (!isNaN(val) && val >= 1 && val <= 365) {
              onChange({ ...settings, defaultQuoteValidityDays: val });
            }
          }}
          slotProps={{
            htmlInput: { min: 1, max: 365, step: 1 },
          }}
          sx={{ maxWidth: 300 }}
        />
      </Paper>
    </>
  );
}
